import * as Sentry from '@sentry/react'
import { isHandledSessionError } from '@utils/handledSessionError'
import { isIgnorableApolloNetworkError } from '@utils/ignorableNetworkError'
import { safeStringify } from '@utils/safeStringify'

/**
 * Gracfully handle the errors and report them
 * to sentry
 *
 * @prop {Error}  err     - Error to report
 * @prop {Object} context - Additional informations
 */
export default function logError(err, context = {}) {
  if (isHandledSessionError(err) || isIgnorableApolloNetworkError(err)) return

  Sentry.withScope(scope => {
    scope.setTag('source', 'logError')

    const extraContext = {
      ...context,
      source: 'logError',
      clientErrors: safeStringify(err.clientErrors),
      graphQLErrors: safeStringify(err.graphQLErrors),
      networkError: err.networkError
        ? {
            message: err.networkError.message,
            stack: err.networkError.stack,
          }
        : undefined,
      name: err.name || undefined,
    }

    Sentry.captureException(err, { extra: extraContext })
  })

  /* eslint-disable no-console */
  //console-log-checker-ignore
  console.error(err)
  // console.log(`Error context: ${JSON.stringify(context, null, 2)}`)
  /* eslint-enable no-console */
}
